<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>招标书列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <swb-call-bid-list-search :no="no" @showCallBidCallSearch="searchCallBidCall"></swb-call-bid-list-search>

        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('create')" @click="toCallBidDocCreate()">新建标书</button>
            </div>
        </div>
        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="(text, value) in callBidDocStateList" :class="{'current': value == checkStateValue}" class="head-item" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="table-layout">
            <table class="custom-tbl" v-if="checkStateValue==0">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="120">采购类型</th>
                    <th width="180">报名截至时间</th>
                    <th width="180">提交时间</th>
                    <th width="120" class="align-left">提交人</th>
                    <th width="120">审核状态</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td v-if="callBidDoc.goodsFlag == true && callBidDoc.servcFlag == true">集成</td>
                    <td v-if="callBidDoc.goodsFlag == true && callBidDoc.servcFlag == false">商品</td>
                    <td v-if="callBidDoc.goodsFlag == false && callBidDoc.servcFlag == true">服务</td>
                    <td>{{callBidDoc.enrollCloseTime}}</td>
                    <td>{{callBidDoc.applyTime}}</td>
                    <td class="align-left">{{callBidDoc.applicantName}}</td>
                    <td v-if="callBidDoc.auditState==0">未审核</td>
                    <td v-if="callBidDoc.auditState==1">通过</td>
                    <td v-if="callBidDoc.auditState==-1">未通过</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState != 1 && checkActionPerm('modify')" class="swb-btn-link" @click="toCallBidDocUpdate(callBidDoc.id)">修改</a>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState != 1 && checkActionPerm('submit_aduit')" class="swb-btn-link" @click="callBidDocApply(callBidDoc.id,'audit')">提交审核</a>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState == 1 && postId == callBidDoc.auditorPostId && checkActionPerm('audit')" class="swb-btn-link" @click="callBidDocAudit(callBidDoc.id, callBidDoc.applyDesc)">审核</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="callBidDocAuditList(callBidDoc.id)">审核记录</a>
                            <a v-if="callBidDoc.auditState == 1 && callBidDoc.published == false && checkActionPerm('publish')" class="swb-btn-link" @click="callBidDocPublish(callBidDoc.id)">发布</a>
                            <a v-if="callBidDoc.published == true && checkActionPerm('view_enroll_list')" class="swb-btn-link" @click="toBidEnrollList(callBidDoc.id)">查看报名列表</a>
                            <!--<a v-if="callBidDoc.published == true && checkActionPerm('view_bid_call_list')" class="swb-btn-link" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">查看投标信息</a>-->
                            <a v-if="callBidDoc.published == true && callBidDoc.resultFlag==0 && checkActionPerm('abort')" class="swb-btn-link">流标</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==1">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="120">采购类型</th>
                    <th width="180">报名截至时间</th>
                    <th width="180">提交时间</th>
                    <th width="120">提交人</th>
                    <th width="120">审核状态</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>
                        <span v-if="callBidDoc.goodsFlag == true && callBidDoc.servcFlag == true">集成</span>
                        <span v-if="callBidDoc.goodsFlag == true && callBidDoc.servcFlag == false">商品</span>
                        <span v-if="callBidDoc.goodsFlag == false && callBidDoc.servcFlag == true">服务</span>
                    </td>
                    <td>{{callBidDoc.enrollCloseTime}}</td>
                    <td>{{callBidDoc.applyTime}}</td>
                    <td class="align-left">{{callBidDoc.applicantName}}</td>
                    <td>
                        <span v-if="callBidDoc.auditState==0">未审核</span>
                        <span v-if="callBidDoc.auditState==1">通过</span>
                        <span v-if="callBidDoc.auditState==-1">未通过</span>
                    </td>

                    <td style="text-align: left">
                        <div>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState != 1 && checkActionPerm('modify')" class="swb-btn-link" @click="toCallBidDocUpdate(callBidDoc.id)">修改</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a v-if="callBidDoc.auditState == 1 && callBidDoc.published == false && checkActionPerm('publish')" class="swb-btn-link" @click="callBidDocPublish(callBidDoc.id)">发布</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id,checkStateValue,callBidDoc.auditState)">编辑招标公告</a>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState != 1 && checkActionPerm('submit_aduit')" class="swb-btn-link" @click="callBidDocApply(callBidDoc.id,'audit')">提交审核</a>
                            <a v-if="callBidDoc.auditState != 1 && callBidDoc.applyState == 1 && postId == callBidDoc.auditorPostId && checkActionPerm('audit')" class="swb-btn-link" @click="callBidDocAudit(callBidDoc.id, callBidDoc.applyDesc)">审核</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="callBidDocAuditList(callBidDoc.id)">审核记录</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==2">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="120">发布时间</th>
                    <th width="180">报名截至时间</th>
                    <th width="180">投标截至时间</th>
                    <th width="120">报名数量</th>
                    <th width="200">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.publishTime}}</td>
                    <td>{{callBidDoc.enrollCloseTime}}</td>
                    <td>{{callBidDoc.closeTime}}</td>
                    <td>{{callBidDoc.enrollNum}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id)">编辑发布公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_enroll_list')" @click="toBidEnrollList(callBidDoc.id)">查看报名列表</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="callBidDocAuditList(callBidDoc.id)">审核记录</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('abort')" @click="setResultFlag(callBidDoc.id)">流标</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==3">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="180">发布时间</th>
                    <th width="180">资格预审结束</th>
                    <th width="180">投标截至时间</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.publishTime}}</td>
                    <td>{{callBidDoc.openTime}}</td>
                    <td>{{callBidDoc.closeTime}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id)">编辑发布公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_enroll_list')" @click="toBidEnrollList(callBidDoc.id)">查看报名列表</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="callBidDocAuditList(callBidDoc.id)">审核记录</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('abort')" @click="setResultFlag(callBidDoc.id)">流标</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==4">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="180">发布时间</th>
                    <th width="180">资格预审结束</th>
                    <th width="180">投标截至时间</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.publishTime}}</td>
                    <td>{{callBidDoc.openTime}}</td>
                    <td>{{callBidDoc.closeTime}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id)">编辑发布公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_bid_call_list')" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">查看投标信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="callBidDocAuditList(callBidDoc.id)">审核记录</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('abort')" @click="setResultFlag(callBidDoc.id)">流标</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==5">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="180">开标时间</th>
                    <th width="120">投标</th>
                    <th width="120">已评标</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.resultPublishTime}}</td>
                    <td>{{callBidDoc.bidNum}}</td>
                    <td>{{callBidDoc.evaluatedNum}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id)">编辑发布公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_bid_call_list')" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">投标信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('abort')" @click="setResultFlag(callBidDoc.id)">流标</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==6">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="180">发布时间</th>
                    <th width="180">中标时间</th>
                    <th width="180" class="align-left">创建人</th>
                    <th width="160">投标</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.publishTime}}</td>
                    <td>{{callBidDoc.resultPublishTime}}</td>
                    <td class="align-left">{{callBidDoc.contactName}}</td>
                    <td>{{callBidDoc.bidNum}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('edit_notice')" @click="editNotice(callBidDoc.id)">编辑发布公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_bid_call_list')" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">投标信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==7">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="150" class="align-left">中标方</th>
                    <th width="200" class="align-left">联系人</th>
                    <th width="200">电话</th>
                    <th width="180">开标时间</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td class="align-left"><a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td class="align-left">{{callBidDoc.winMerchantName}}</td>
                    <td class="align-left">{{callBidDoc.winContactName}}</td>
                    <td>{{callBidDoc.winContactTel}}</td>
                    <td>{{callBidDoc.resultPublishTime}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_bid_call_list')" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">投标信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==8">
                <thead class="head">
                <tr class="row">
                    <th width="200">招标编号</th>
                    <th width="200" class="align-left">招标标题</th>
                    <th width="180">发布时间</th>
                    <th width="180">流标时间</th>
                    <th width="160" class="align-left">创建人</th>
                    <th width="160">投标</th>
                    <th width="300">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="callBidDoc in callBidDocList">
                    <td>{{callBidDoc.no}}</td>
                    <td style="text-align: left" :title="callBidDoc.title">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(callBidDoc.id)">{{callBidDoc.title}}</a></td>
                    <td>{{callBidDoc.publishTime}}</td>
                    <td>{{callBidDoc.resultPublishTime}}</td>
                    <td class="align-left">{{callBidDoc.contactName}}</td>
                    <td>{{callBidDoc.bidNum}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(callBidDoc.id)">查看公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_bid_call_list')" @click="toBidDocList(callBidDoc.id,checkStateValue,callBidDoc.closeTime)">投标信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('relate')" @click="showSourceTraceDlg(callBidDoc)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && callBidDoc.srcFlag > 0" @click="cancelRelate(callBidDoc.id)">取消来源</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="viewCallBidActRecList(callBidDoc.id)">查看操作记录</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'

    import appConf from '../../app.conf';
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'

    import { checkUserActionPerm } from '../index'

    import { openCallBidActRecListDlg } from './selectDlg'

    //
    import userApi from '../../api/user'
    import callBidApi from '../../api/callBid'

    import SwbCallBidDocAudit from './CallBidDocAudit';

    Vue.regist(SwbCallBidDocAudit);

    import SwbBidEnrollList from './BidEnrollList';

    Routes.add(SwbBidEnrollList);

    import SwbCallBidDocInfo from './CallBidDocInfo';

    Routes.add(SwbCallBidDocInfo);

    import swbCallBidDocAuditList from './CallBidDocAuditList.vue'

    Vue.regist(swbCallBidDocAuditList);

    import SwbCallBidNoticeList from './CallBidNoticeList';

    Vue.regist(SwbCallBidNoticeList);

    import SwbDeviceRequireVoucherForSelect from '../retailer/DeviceRequireVoucherForSelect';

    Vue.regist(SwbDeviceRequireVoucherForSelect);

    import SwbCallBidDocCreate from './CallBidDocCreate';

    Routes.add(SwbCallBidDocCreate);

    import SwbBidDocList from './BidDocList';

    Routes.add(SwbBidDocList);

    import SwbDeviceRequireVoucherManager from '../retailer/DeviceRequireVoucherManager';

    Routes.add(SwbDeviceRequireVoucherManager);

    import SwbCallBidListSearch from './CallBidDocListSearch';

    Vue.regist(SwbCallBidListSearch);

    export default {
        name: 'swb-call-bid-doc-list',
        path: '/call/bid/doc/list',
        avlActions: 'create|modify|apply|audit|view_audit_rec|publish|view_notice|edit_notice|submit_aduit|view_enroll_list|view_bid_call_list|abort|relate|cancelRelate',
        avlActionNames: '新建标书、修改、查看公告、编辑招标公告、提交审核、审核记录、来源管理、发布、审核、编辑发布公告、查看报名列表、流标、投标信息',
        avlScopes: 'retailer',
        desc: '招标书列表',
        helpArticleCode: 'retailer-call-bid-doc-list',
        //props: ['id'],
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                callBidDocList: [],
                callBidDocStateList: [],
                callBidNotice: {},
                checkStateValue: 0,
                userInfo: {
                    userId: null,
                },
                postId: null,
                headCount: [],
                type: null,
                //排序、搜索
                queryConfig: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                queryConfigMap: {},
                no: null
            }
        },
        created: function () {
            let self = this;
            //----------------------分页--------------------------------
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //----------------------查询------------------------------

            let no = self.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.no = no;
                this.queryModel.filterItems.no = no;
            }

            let checkStateValue = this.$route.query.checkState || null;
            if(checkStateValue != null) {
                self.getCallBidDocList(checkStateValue);
            } else {
                self.getCallBidDocList(0);
            }
            //
            self.userCurrentInfo();
            //

            //
            self.getCallBidDocNumber();

            // 过滤条件 枚举
            let callBidDocStateList = getEnumMap('callBidDocState', 'value2text');
            for(let key in callBidDocStateList) {
                if(key == 9) {
                    delete callBidDocStateList[key];
                    break;
                }
            }
            self.callBidDocStateList = callBidDocStateList;
        },
        methods: {
            viewCallBidActRecList(docId){
                openCallBidActRecListDlg(docId);
            },
            searchCallBidCall: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getCallBidDocList(this.checkStateValue);
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            // 页签切换
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getCallBidDocList(val);
            },
            handleSizeChange: function (val) {
                let curStartIndex = this.pageNumber * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getCallBidDocList(this.checkStateValue);
            },

            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.getCallBidDocList(this.checkStateValue);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },

            userCurrentInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.postId = userInfo.scopeEntity.postId;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getCallBidDocNumber: function () {
                let self = this;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocNumber(function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.headCount = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCallBidDocList: function (value) {
                let self = this;

                self.checkStateValue = value;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.callBidState = value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let resultFlagList = getEnumMap('callBidResultFlag', 'value2text');
                        self.callBidDocList = result.data.rows;
                        let callBidDocList = self.callBidDocList;
                        for(let i = 0; i < callBidDocList.length; i++) {
                            callBidDocList[i].resultFlag = resultFlagList[callBidDocList[i].resultFlag];
                        }
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            lookNotice: function (content) {
                let self = this;
                Vue.$showDialog({
                    title: '查看 - 公告',
                    showCloseBtn: true,
                    width: 800,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice :content="content" ref="swb_call_bid_notice"></swb-call-bid-notice>' +
                    '</div>',
                    data: {
                        content: null,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {
                        created: function () {
                            this.content = content;
                        }
                    }

                });
            },
            getCallBidNoticeByCallBidDocId: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '公告列表 - 查看',
                    showCloseBtn: true,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice-list :docId="docId" :state="state" ref="swb_call_Bid_notice_list"></swb-call-bid-notice-list>' +
                    '</div>',
                    data: {
                        docId: id,
                        state: self.checkStateValue,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {}

                });
            },
            // 申请
            callBidDocApply: function (id, action) {
                let self = this;
                //
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: action,
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: id,
                        //
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.actionPostName,
                        //
                        applyDesc: resultData.applyDesc
                    };
                    //
                    let theLoad = MsgBox.loading();
                    callBidApi.applyCallBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            self.getCallBidDocList(self.checkStateValue);
                        } else {
                            MsgBox.failure(result.message);
                        }
                        theLoad.hide();
                    });

                }, this);

            },
            // 审核
            callBidDocAudit: function (id, applyDesc) {
                let self = this;
                showBizAuditDlg({
                    title: "招标书 - 审核",
                    applyDesc: applyDesc,
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    let theLoad = MsgBox.loading();
                    callBidApi.auditCallBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            self.getCallBidDocList(self.checkStateValue);
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }, this);
            },

            callBidDocAuditList: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "审核列表",
                    width: '80%',
                    height: 500,
                    centerButtons: false,
                    showCloseBtn: true,
                    cancelVisible: false,
                    okVisible: false,
                    template: '<swb-call-bid-doc-audit-list :id="id" ref="swb_call_bid_doc_audit_list"></swb-call-bid-doc-audit-list>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: id
                    },
                });
            },

            // 发布
            callBidDocPublish: function (id) {
                let self = this;
                this.$confirm('是否确定发布 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    callBidApi.publishCallBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            self.getCallBidDocList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }).catch(function () {
                });
            },
            // 查看报名列表
            toBidEnrollList: function (id) {
                this.$router.push({
                    path: SwbBidEnrollList.path,
                    query: {
                        docId: id,
                        checkState: this.checkStateValue
                    }
                });
            },

            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);

                if(currTime.getTime() > dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },

            toCallBidDocInfo: function (id) {
                this.$router.push({
                    path: SwbCallBidDocInfo.path,
                    query: {
                        callBidDocId: id,
                        checkState: this.checkStateValue
                    }
                });
            },
            toCallBidDocCreate: function () {   // 创建发标书
                this.$router.push({
                    path: SwbCallBidDocCreate.path,
                    query: {
                        checkState: this.checkStateValue
                    }
                });
            },

            toCallBidDocUpdate: function (id) {   //
                this.$router.push({
                    path: SwbCallBidDocCreate.path,
                    query: {
                        callBidDocId: id,
                        checkState: this.checkStateValue
                    }
                });
            },
            toBidDocList: function (id, type, closeTime) {     // 招标管理
                this.$router.push({
                    path: SwbBidDocList.path,
                    query: {
                        callDocId: id,
                        type: type,
                        closeTime: closeTime,
                        checkState: this.checkStateValue
                    }
                });
            },
            setResultFlag: function (id) {    // 流标设置
                let self = this;
                let inputDlg = MsgBox.prompt('流标原因', function (value) {
                    inputDlg.close();
                    let postData = {};
                    postData.id = id;
                    postData.resultDesc = value;
                    let theLoad = MsgBox.loading();
                    callBidApi.abortCallBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success("成功");
                            self.getCallBidDocList(self.checkStateValue);

                        } else {
                            MsgBox.failure(result.message);
                        }
                        theLoad.hide();
                    });
                }, {
                    type: 'mltext',
                    value: '',
                    maxLenght: 250
                });
            },

            editNotice: function (docId, checkStateValue, auditState) {
                let self = this;
                let paramsData = {};
                paramsData.docId = docId;
                callBidApi.getCallBidNoticeCountByDocId(paramsData, function (result) {
                    if(result.type === "info") {
                        let countBoolean = result.data;
                        if(countBoolean == true) {
                            self.getCallBidNoticeByDocIdAndPublished(docId, countBoolean, auditState);
                        } else {
                            self.editCallBidNotic(null, docId, countBoolean, auditState);
                        }
                    }
                });

            },

            editCallBidNotic: function (id, docId, add, auditState) {
                let self = this;
                Vue.$showDialog({
                    title: '编辑 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-call-bid-notice-save :add="add" :docId="docId" :id="id" :state="state" ref="swb_call_bid_notice_save"></swb-call-bid-notice-save>' +
                    '</div>',
                    data: {
                        docId: docId,
                        id: id,
                        add: add,
                        state: null,
                    },
                    okText: '保存',
                    okClicked: function () {
                        let result = this.$refs.swb_call_bid_notice_save.getDlgResult() || {};
                        if(result.type == "info") {
                            let postData = {};
                            postData = result.data;
                            postData.published = false;
                            let theLoad = MsgBox.loading();
                            callBidApi.saveCallBidNotice(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                                theLoad.hide();
                            })
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    method: {},
                    lifecycle: {
                        created: function () {
                            this.state = self.checkStateValue;
                        }
                    }
                });
            },

            //查看是否有未发布的公告
            getCallBidNoticeByDocIdAndPublished: function (docId, countBoolean, auditState) {    // 流标设置
                let self = this;
                let postData = {};
                postData.docId = docId;
                postData.published = false;
                callBidApi.getCallBidNoticeByDocIdAndPublished(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidNotice = result.data;
                        if(callBidNotice != null) {
                            let id = callBidNotice.id;
                            self.editCallBidNotic(id, docId, countBoolean, auditState)
                        } else {
                            self.editCallBidNotic(null, docId, countBoolean, auditState);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            updateCallBidDoc: function () {
                this.$router.push({
                    path: SwbBidDocList.path,
                    query: {
                        callDocId: id,
                        type: type,
                        checkState: this.checkStateValue
                    }
                });
            },
            showSourceTraceDlg: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '跟踪信息',
                    showCloseBtn: true,
                    height: 600,
                    template: '<div>' +
                    '<swb-device-require-voucher-for-select :srcId = "srcId" :showSelect="showSelect" :toDeviceRequireVoucherList="toDeviceRequireVoucherList" ref="swb_device_require"></swb-device-require-voucher-for-select>' +
                    '</div>',
                    data: {
                        srcId: row.srcId,
                        showSelect: false
                    },
                    methods: {
                        toDeviceRequireVoucherList: function (no) {
                            self.toDeviceRequireVoucherList(no);
                        },
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_device_require.getDlgResult() || {};
                        if(result.type == "info") {
                            row.srcId = result.data.srcId;
                            row.srcFlag = result.data.srcFlag;
                            row.resultFlag = 0;
                            callBidApi.updateCallBidDocSrc(row, function (result) {
                                if(result.type === "info") {
                                    MsgBox.success('设置成功');
                                    self.getCallBidDocList(self.checkStateValue);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.showSelect = true;
                        }
                    }
                });
            },
            toDeviceRequireVoucherList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl(SwbDeviceRequireVoucherManager.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            cancelRelate: function (id) {
                let self = this;
                this.$confirm('是否确定取消此来源 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postParam = {};
                    postParam.id = id;
                    callBidApi.cancelCallBidDocSrc(postParam, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('取消成功');
                            self.getCallBidDocList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },

        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocList.vue